import { lazy } from 'react';

const lazyComponent = (lazyImportFunction, props) => {
  const Component = lazy(lazyImportFunction);
  return <Component {...props} />;
};

export default lazyComponent;
